"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var groupingNavigation = [{
  order: 1,
  name: _constants.GroupingValues.GROUPS_TOP_PARENT
}, {
  order: 2,
  name: _constants.GroupingValues.ALL_USERS
}, {
  order: 2,
  name: _constants.GroupingValues.ALL_GROUPS_CHILDREN
}, {
  order: 2,
  name: _constants.GroupingValues.GROUPS_CHILDREN
}, {
  order: 3,
  name: _constants.GroupingValues.USERS
}];

var buildGroupingHierarchy = function buildGroupingHierarchy(_ref) {
  var groupingConfig = _ref.groupingConfig,
      groupingHierachyConfig = _ref.groupingHierachyConfig;

  if (groupingHierachyConfig) {
    return groupingHierachyConfig;
  }

  var orderedGroupingNavigation = groupingNavigation.sort(function (a, b) {
    return a.order - b.order;
  });
  var filteredGroupings = orderedGroupingNavigation.filter(function (item) {
    return Object.keys(groupingConfig).includes(item.name) && groupingConfig[item.name] === true;
  });
  var groupingHierarchy = filteredGroupings.reduce(function (acc, current, currentIndex) {
    var next = filteredGroupings.find(function (currentGroupings, currentGroupingsIndex) {
      return currentGroupingsIndex > currentIndex && currentGroupings.order > current.order;
    });
    var previous = filteredGroupings.slice().reverse().find(function (currentGroupings) {
      return currentGroupings.order < current.order;
    });
    return _objectSpread({}, acc, (0, _defineProperty2["default"])({}, current.name, {
      next: next && next.name,
      previous: previous && previous.name
    }));
  }, {});
  return groupingHierarchy;
};

var _default = buildGroupingHierarchy;
exports["default"] = _default;
//# sourceMappingURL=buildGroupingHierarchy.js.map